import { styled } from 'goober';

export const Button = styled('button')`
  width: 100%;
  display: flex;
  color: #3d3d3d;
  max-width: 240px;
  font-weight: 700;
  padding: 0 2rem;
  min-height: 52px;
  font-size: 1.125rem;
  line-height: 1.25rem;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  background-color: #f6c26e;

  &:disabled {
    opacity: 0.6;
    pointer-events: none;
  }
`;
